import { ServiceBase } from '../../../../../../core/services/ServiceBase'
import InternationalPreviewProxy from '../proxies/InternationalPreviewProxy'

class InternationalPreviewService extends ServiceBase {
  getCompanyDetail(params) {
    return this.getData(() =>
      InternationalPreviewProxy.getCompanyDetail(params),
    )
  }

  getProducts(params) {
    return this.getData(() => InternationalPreviewProxy.getProducts(params))
  }

  getOrderRequest(params) {
    return this.getData(() => InternationalPreviewProxy.getOrderRequest(params))
  }
}

export default new InternationalPreviewService()
